export function linearTween(
	timeElapsed: number,
	start: number,
	distance: number,
	duration: number
) {
	return (distance * timeElapsed) / duration + start;
}
